module.exports = __webpack_public_path__ + "close.e1175eaa.png";